const state = require('./state.js');
const ui = require('../ui');
const insuredState = require('../insured/state.js');
const vehicleState = require('../vehicle/state.js');
const DOM = require('./dom.js');
const { useDisableSpace, useLabel, useVisibility, useFocus, useValidation, useKeys } = require('../common.js');
const { AttachState } = require('../helpers.js');

export const validateEmail = (email) => {
    if (!email || email.length > 320)
        return false;

    var parts = email.split('@');

    if (parts.length != 2
        || parts[0].length == 0 || parts[0].length > 64 || parts[0].includes('..') || parts[0].startsWith('.') || parts[0].endsWith('.') || !(/^[a-zA-Z0-9_.-]+$/).test(parts[0])
        || parts[1].length == 0 || parts[1].length > 255 || parts[1].includes('..') || parts[1].startsWith('.') || parts[1].endsWith('.'))
        return false;

    var labels = parts[1].split('.');

    if (labels.length < 2 || labels.length > 4)
        return false;

    for (var i = 0; i < labels.length; i++)
        var label = labels[i];
    if (label.length == 0 || label.length > 255 || !(/^[a-zA-Z0-9]+$/).test(label))
        return false;

    if (!(/^[a-zA-Z]+$/).test(labels[labels.length - 1]))
        return false;

    return true;
};

export const validatePhone = (phone) => {
    return /^(07|00407)[0-9]{8}$/.test(phone);
};

export const phoneNumberWithRoPrefix = (phone) => {
    if (phone.startsWith('07'))
        return '004' + phone;
    return phone;
};

export const init = () => {
    if (vehicleState.plateNo) {
        state.plateNo = vehicleState.plateNo;
        txtPlateNo.state.visible = false;
    } else {
        txtPlateNo.state.visible = true;
        setTimeout(() => {
            DOM.txtVehiclePlateNo.focus();
        }, 600);
    }

    if (!txtPlateNo.state.visible) {
        divVehicleInformation.state.visible = false;
        setTimeout(() => {
            DOM.txtInsuredEmail.focus();
        }, 600);
    }

    if (insuredState.isCompany) {
        txtFirstName.state.label = 'Denumire';
        txtLastName.state.visible = false;
        if (insuredState.name) {
            state.firstName = insuredState.name;
            txtFirstName.state.focused = true;
        }
    } else {
        txtFirstName.state.label = 'Prenume';
        txtLastName.state.visible = true;
        if (insuredState.name) {
            let nameParts = insuredState.name.split(' ');
            if (nameParts.length > 0) {
                state.lastName = nameParts[0];
                let firstName = '';
                if (nameParts.length > 1) {
                    for (let i = 1; i < nameParts.length; i++) {
                        if (firstName !== '')
                            firstName += ' ';

                        firstName += nameParts[i];
                    }
                }
                state.firstName = firstName;

                txtFirstName.state.focused = true;
                txtLastName.state.focused = true;
            }
        }
    }

    if (insuredState.street) {
        state.street = insuredState.street;
        DOM.txtInsuredStreet.disabled = true;
        txtStreet.state.focused = true;
    }
    if (insuredState.personalInformation) {
        if (insuredState.personalInformation.Email) {
            state.email = insuredState.personalInformation.Email;
            txtEmail.state.focused = true;
        }
        if (insuredState.personalInformation.Mobile) {
            state.phone = insuredState.personalInformation.Mobile;
            if (!state.phone.startsWith('0'))
                state.phone = `0${state.phone}`;
            txtPhone.state.focused = true;
        }
        if (insuredState.personalInformation.StreetNo) {
            state.streetNo = insuredState.personalInformation.StreetNo;
            txtStreetNo.state.focused = true;
        }
    }
};

let txtPlateNo = useDisableSpace(useVisibility(useValidation(useFocus(DOM.txtVehiclePlateNo))));
let txtFirstName = useLabel(useValidation(useFocus(DOM.txtInsuredFirstName)));
let txtLastName = useVisibility(useValidation(useFocus(DOM.txtInsuredLastName)));
let txtEmail = useDisableSpace(useValidation(useFocus(DOM.txtInsuredEmail)));
let txtPhone = useDisableSpace(useValidation(useFocus(DOM.txtInsuredPhone)));
let txtStreet = useValidation(useFocus(DOM.txtInsuredStreet));
let txtStreetNo = useValidation(useFocus(DOM.txtInsuredStreetNo));
useKeys(DOM.btnDetailsBack);
useKeys(DOM.btnDetailsNext);
let divVehicleInformation = (AttachState({
    visible: true
}, (state, DOM) => {
    let div = DOM.parentElement.parentElement.parentElement.parentElement;

    state.bind('visible', value => {
        div.style.display = value ? '' : 'none';
    });
}))(DOM.txtVehiclePlateNo);

state.bind('plateNo', txtPlateNo.root);
state.bind('firstName', txtFirstName.root);
state.bind('lastName', txtLastName.root);
state.bind('email', txtEmail.root);
state.bind('phone', txtPhone.root);
state.bind('street', txtStreet.root);
state.bind('streetNo', txtStreetNo.root);

DOM.btnDetailsBack.addEventListener('click', () => {
    ui.state.slide = [2, 0];
});
DOM.btnDetailsNext.addEventListener('click', () => {
    let isValid = true;

    txtPlateNo.state.valid = true;
    txtFirstName.state.valid = true;
    txtLastName.state.valid = true;
    txtEmail.state.valid = true;
    txtPhone.state.valid = true;
    txtStreet.state.valid = true;
    txtStreetNo.state.valid = true;

    if (!state.plateNo || !state.plateNo.replace(/\s/ig, '') || !state.plateNo.match(/^[a-z]{1,9}\d{1,9}[a-z]{1,9}/ig)) {
        txtPlateNo.state.valid = false;
        txtPlateNo.state.visible = true;
        divVehicleInformation.state.visible = true;
        isValid = false;
    }
    if (!state.firstName || state.firstName.length < 3) {
        txtFirstName.state.valid = false;
        isValid = false;
    }
    if (!insuredState.isCompany) {
        if (!state.lastName || state.lastName.length < 3) {
            txtLastName.state.valid = false;
            isValid = false;
        }
    }
    if (!state.email) {
        txtEmail.state.valid = false;
        isValid = false;
    } else {
        if (!validateEmail(state.email)) {
            txtEmail.state.valid = false;
            isValid = false;
        }
    }
    if (!state.phone) {
        txtPhone.state.valid = false;
        isValid = false;
    } else {
        if (!validatePhone(state.phone)) {
            txtPhone.state.valid = false;
            isValid = false;
        }
    }
    if (!state.street) {
        txtStreet.state.valid = false;
        isValid = false;
    }
    if (!state.streetNo) {
        txtStreetNo.state.valid = false;
        isValid = false;
    }

    if (!isValid)
        return;

    ui.state.slide = [3, 1];
});

module.exports.state = state;
module.exports.DOM = DOM;